import mixinDependencies from 'shared/angularjs/services/acp-modal-state-provider';
import states from './states';

export default function(appModule) {
  mixinDependencies(appModule);
  appModule.config(states);
}
